<button class="btn btn-back w-fitcontent background px-3 px-md-5 py-3 py-md-5" (click)="goToHomepage()" style="max-width: 300px">
  <fa-icon [icon]="faChevronLeft"></fa-icon>
  <span class="ms-2" style="align-self: center; font-size: 0.9rem; font-weight: 500" translate>
    actions.homepage
  </span>
</button>

@if (showFaq) {
  <div class="card-body px-3 px-md-5">
    <div class="row gx-0 col-12">
      <div class="col-md-9 align-center">
        <h1 class="title" translate>rda.title</h1>
        <h2 class="extra-small-margin" translate>
          rda.subtitle1
        </h2>
        <h2 class="extra-small-margin">
          <span>{{subtitle}}</span>
        </h2>
        <h2 class="extra-small-margin pb-5">
          <span>{{ subtitle2 | translate }}</span>
        </h2>
      </div>
    </div>
    <div class="card full-card shadow-sm card-v-center">
      <div class="row gx-0 mt-3">
        <div class="form-group col-12">
          <div class="form-group col-6 p-1">
            <h3 class="text-center mt-4"><b translate>pre-login-faq.search</b></h3>
          </div>
          <!--search label-->
          <div class="form-group col-6 p-1">
            <h3 class="text-center mt-4"><b translate>pre-login-faq.search-categories</b></h3>
          </div>
        </div>
      </div>
      <div class="row px-4 gx-0">
        <div class="form-group col-12">
          <div class="form-group col-6 p-1">
            <input type="text" class="w-100 form-control form-input input-with-border" id="floatingInputValue"
              (ngModelChange)="onSearch()" [(ngModel)]="filters.question" name="question"
              [placeholder]=" 'rda.search.placeholder' | translate " />
          </div>
          <div class="form-group col-6 p-1">
            <ng-select [items]="callFaqsCategories" [(ngModel)]="filters.category" [searchable]="false" (ngModelChange)="onSearch()"
              placeholder="{{'faq-list.category.placeholder' | translate}}">
              <ng-template ng-option-tmp let-item="item">
                    {{item}}
               </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
      <!--form category-->
      <!--ng-select-->
      @if (callFaqs != undefined) {
        <div class="row gx-0 px-4 mt-3">
          <div class="form-group col-12">
            <!--/ng-select-->
            <hr class="line medium-margin" />
            @if (callFaqs.length > 0) {
              <div>
                @for (item of callFaqs; track item) {
                  <div>
                    <div class="row gx-0 col-12 pb-1 px-1">
                      <!-- question -->
                      <div class="col">
                        <p class="font-weight-bold text-black faq-question" [innerHTML]="item.question"></p>
                      </div>
                      <div class="col-auto">
                        @if (item.collapsed) {
                          <fa-icon [icon]="faAngleUp" size="2x" class="text-primary" style="cursor: pointer"
                          (click)="toggleAccordion(item)"></fa-icon>
                        }
                        @if (!item.collapsed) {
                          <fa-icon [icon]="faAngleDown" size="2x" class="text-primary" style="cursor: pointer"
                          (click)="toggleAccordion(item)"></fa-icon>
                        }
                      </div>
                      @if (item.collapsed) {
                        <div class="col-12">
                          <p class="col answer faq-answer" [innerHTML]="item.answer"></p>
                        </div>
                      }
                    </div>
                    <hr class="line" />
                  </div>
                }
              </div>
            }
            @if (callFaqs.length === 0) {
              <div>
                <p class="answer text-center" translate>no.faq.value</p>
              </div>
            }
          </div>
        </div>
      }
      @if (callFaqs == undefined) {
        <div style="height: 400px;">
          <div class="d-flex justify-content-center">
            <fa-icon [icon]="faCircleNotch" class="fill-orange fa-4x fa-spin"></fa-icon>
          </div>
        </div>
      }
    </div>
    <!--pagination-->
    <div class="row gx-0 justify-content-between table-paginator mt-3 ms-2">
      <div class="col-md-4">
        @if (pagination) {
          <pwc-pagination [page]="pagination.number + 1" [pageSize]="pagination.size"
            [collectionSize]="pagination.totalElements" (pageChange)="onPageChange($event)"
          [showCollectionSize]="false"></pwc-pagination>
        }
      </div>
    </div>
    <!--pagination-->
  </div>
}

<div class="card full-card shadow-sm my-6">
  <div class="cardHelpDesk card-body row gx-0 gx-md-3">
    <div class="col-12 lookingFor col-md-6 justify-content-center">
      <h3><b translate>pre-login-faq.footer-title</b></h3>
    </div>
    <div class="col-12 col-md-4 center">
      <button type="button" class="buttonHelp btn btn-primary" routerLink="/bandi/help-desk">
        <b translate>pre-login-faq.footer-button</b>
      </button>
    </div>
  </div>
</div>
